import React from "react";
import { Container } from "react-bootstrap";

const Description = () => {
  return (
    <div className="homeDescription mb-5">
      <Container className="homeDescriptionText1">
        Example of login Api call in different backend server and Jwt
      </Container>
    </div>
  );
};

export default Description;
